import React from "react";

function Copyright() {
  return (
    <div className="copyright-section">
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        
        <p className="mb-0">
          Copyright © 2026 Beyond Cool Products and Services LLP || All rights reserved.
        </p>

        <p className="mb-0">
          Designed & Developed by{" "}
          <a
            href="https://janrise.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#f8d84b",
              textDecoration: "none",
            }}
          >
            Janrise
          </a>
        </p>

      </div>
    </div>
  );
}

export default Copyright;